// src/components/MenuSelect.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../App.css';

const MenuSelect = ({ onMenuChange }) => {
  const [menus, setMenus] = useState(['All']);
  const [selectedMenu, setSelectedMenu] = useState('All');
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMenus = async () => {
      const id_account_caisse = localStorage.getItem('id_account_caisse');
      const id_caisse = localStorage.getItem('id_caisse');

      if (!id_account_caisse || !id_caisse) {
        setError('Missing account or caisse ID');
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `https://apiTicket.lalivraison.ma/api/menus/${id_caisse}`,
          {
            params: { id_account_caisse },
            timeout: 5000,
          }
        );

        if (response.data?.menus && Array.isArray(response.data.menus)) {
          // Ensure menus match nom_imprimante values
          const fetchedMenus = response.data.menus.filter((menu) => typeof menu === 'string' && menu.trim());
          setMenus(['All', ...fetchedMenus]);
        } else {
          throw new Error('Invalid menus data format');
        }
      } catch (error) {
        console.error('Menu fetch error:', error);
        setError('Failed to load menus. Using default option.');
        setMenus(['All']);
      } finally {
        setLoading(false);
      }
    };

    fetchMenus();
  }, []);

  const handleMenuSelect = (menu) => {
    setSelectedMenu(menu);
    onMenuChange(menu);
    setIsOpen(false);
  };

  return (
    <div className="menu-select-container">
      {loading ? (
        <div>Loading menus...</div>
      ) : error ? (
        <div className="error">Only 'All' available</div>
      ) : (
        <>
          <div className="menu-select" onClick={() => setIsOpen(!isOpen)}>
            {selectedMenu}
            <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
          </div>
          {isOpen && (
            <div className="menu-dropdown">
              {menus.map((menu) => (
                <div
                  key={menu}
                  className={`menu-item ${menu === selectedMenu ? 'selected' : ''}`}
                  onClick={() => handleMenuSelect(menu)}
                >
                  {menu}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MenuSelect;